module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edi-reciept"
  }, [_c('ul', {
    staticClass: "ui-listview edi-reciept-top order"
  }, [_c('li', [_c('div', {
    staticClass: "head"
  }, [_c('h4', [_vm._v("餐企订单")]), _vm._v(" "), _c('router-link', {
    staticClass: "ui-btn-icon-right ui-icon-carat-r",
    attrs: {
      "to": {
        path: '/all-order-bill',
        query: {
          bill_state: '10,11,12,13,14',
          bill_font: '未处理,待发货,已发货,已收货 待确认, 已收货 已确认'
        }
      }
    }
  }, [_vm._v("查看全部订单")])], 1), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    staticClass: "none",
    attrs: {
      "to": {
        path: '/all-order-bill',
        query: {
          bill_state: '10',
          bill_font: '未处理'
        }
      }
    }
  }, [_c('i', [(_vm.countShow(_vm.count.order_unhandled_num)) ? _c('em', [_vm._v(_vm._s(_vm.count.order_unhandled_num))]) : _vm._e()]), _vm._v("未处理\n\t\t\t\t")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "wait",
    attrs: {
      "to": {
        path: '/all-order-bill',
        query: {
          bill_state: '11',
          bill_font: '待发货'
        }
      }
    }
  }, [_c('i', [(_vm.countShow(_vm.count.order_accept_num)) ? _c('em', [_vm._v(_vm._s(_vm.count.order_accept_num))]) : _vm._e()]), _vm._v("待发货\n\t\t\t\t")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "done",
    attrs: {
      "to": {
        path: '/all-order-bill',
        query: {
          bill_state: '12',
          bill_font: '已发货'
        }
      }
    }
  }, [_c('i'), _vm._v("已发货")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "done",
    attrs: {
      "to": {
        path: '/all-order-bill',
        query: {
          bill_state: '13',
          bill_font: '已收货 待确认'
        }
      }
    }
  }, [_c('i', [(_vm.countShow(_vm.count.order_received_num)) ? _c('em', [_vm._v(_vm._s(_vm.count.order_received_num))]) : _vm._e()]), _vm._v("已收货\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "done",
    attrs: {
      "to": {
        path: '/all-order-bill',
        query: {
          bill_state: '14,15,16,17',
          bill_font: '已收货 已确认'
        }
      }
    }
  }, [_c('i', [(_vm.countShow(_vm.count.order_confirmed_num)) ? _c('em', [_vm._v(_vm._s(_vm.count.order_confirmed_num))]) : _vm._e()]), _vm._v("已确认\n\t\t\t\t\t")])], 1)])])]), _vm._v(" "), _c('ul', {
    staticClass: "ui-listview refund"
  }, [_c('li', [_c('div', {
    staticClass: "head"
  }, [_c('h4', [_vm._v("餐企退单")]), _vm._v(" "), _c('router-link', {
    staticClass: "ui-btn-icon-right ui-icon-carat-r",
    attrs: {
      "to": {
        path: '/all-return-bill',
        query: {
          bill_state: '20,21',
          bill_font: '未确认,已确认'
        }
      }
    }
  }, [_vm._v("查看全部退单")])], 1), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    staticClass: "wait",
    attrs: {
      "to": {
        path: '/all-return-bill',
        query: {
          bill_state: '20',
          bill_font: '未确认'
        }
      }
    }
  }, [_c('i', [(_vm.countShow(_vm.count.reverse_uncfmd_num)) ? _c('em', [_vm._v(_vm._s(_vm.count.reverse_uncfmd_num))]) : _vm._e()]), _vm._v("未确认\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "done",
    attrs: {
      "to": {
        path: '/all-return-bill',
        query: {
          bill_state: '21',
          bill_font: '已确认'
        }
      }
    }
  }, [_c('i'), _vm._v("已确认\n\t\t\t\t\t")])], 1)])])]), _vm._v(" "), _c('ul', {
    staticClass: "ui-listview refund"
  }, [_c('li', [_c('div', {
    staticClass: "head"
  }, [_c('h4', [_vm._v("餐企报价单")]), _vm._v(" "), _c('router-link', {
    staticClass: "ui-btn-icon-right ui-icon-carat-r",
    attrs: {
      "to": {
        path: '/quotation-bill',
        query: {
          bill_state: '30,31,32,35',
          bill_font: '未确认,已同意,已确认,已定价'
        }
      }
    }
  }, [_vm._v("查看全部报价单\n\t\t\t\t")])], 1), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    staticClass: "wait",
    attrs: {
      "to": {
        path: '/quotation-bill',
        query: {
          bill_state: '30',
          bill_font: '未确认'
        }
      }
    }
  }, [_c('i', [(_vm.countShow(_vm.count.quoter_unhandled_num)) ? _c('em', [_vm._v(_vm._s(_vm.count.quoter_unhandled_num))]) : _vm._e()]), _vm._v("未确认\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "done",
    attrs: {
      "to": {
        path: '/quotation-bill',
        query: {
          bill_state: '31',
          bill_font: '已同意'
        }
      }
    }
  }, [_c('i', [(_vm.countShow(_vm.count.quoter_accept_num)) ? _c('em', [_vm._v(_vm._s(_vm.count.quoter_accept_num))]) : _vm._e()]), _vm._v("已同意\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "done",
    attrs: {
      "to": {
        path: '/quotation-bill',
        query: {
          bill_state: '32',
          bill_font: '已确认'
        }
      }
    }
  }, [_c('i'), _vm._v("已确认")])], 1)])])]), _vm._v(" "), _c('ul', {
    staticClass: "ui-listview refund"
  }, [_c('li', [_c('div', {
    staticClass: "head"
  }, [_c('h4', [_vm._v("餐企询价单")]), _vm._v(" "), _c('router-link', {
    staticClass: "ui-btn-icon-right ui-icon-carat-r",
    attrs: {
      "to": {
        path: '/inquiry-price-bill',
        query: {
          bill_state: '40,41,42',
          bill_font: '未确认,已同意,已确认'
        }
      }
    }
  }, [_vm._v("查看全部询价单")])], 1), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    staticClass: "wait",
    attrs: {
      "to": {
        path: '/inquiry-price-bill',
        query: {
          bill_state: '40',
          bill_font: '未确认'
        }
      }
    }
  }, [_c('i', [(_vm.countShow(_vm.count.inquiry_unhandled_num)) ? _c('em', [_vm._v(_vm._s(_vm.count.inquiry_unhandled_num))]) : _vm._e()]), _vm._v("未确认\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "done",
    attrs: {
      "to": {
        path: '/inquiry-price-bill',
        query: {
          bill_state: '41',
          bill_font: '已同意'
        }
      }
    }
  }, [_c('i', [(_vm.countShow(_vm.count.inquiry_accept_num)) ? _c('em', [_vm._v(_vm._s(_vm.count.inquiry_accept_num))]) : _vm._e()]), _vm._v("已同意\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "done",
    attrs: {
      "to": {
        path: '/inquiry-price-bill',
        query: {
          bill_state: '42',
          bill_font: '已确认'
        }
      }
    }
  }, [_c('i'), _vm._v("已确认")])], 1)])])]), _vm._v(" "), _c('ul', {
    staticClass: "ui-listview refund"
  }, [_c('li', [_c('div', {
    staticClass: "head"
  }, [_c('h4', [_vm._v("餐企对账单")]), _vm._v(" "), _c('router-link', {
    staticClass: "ui-btn-icon-right ui-icon-carat-r",
    attrs: {
      "to": {
        path: '/account-check-bill',
        query: {
          bill_state: '0,1',
          bill_font: '未确认,已确认'
        }
      }
    }
  }, [_vm._v("查看全部对账单")])], 1), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    staticClass: "wait",
    attrs: {
      "to": {
        path: '/account-check-bill',
        query: {
          bill_state: '0',
          bill_font: '未确认'
        }
      }
    }
  }, [_c('i', [(_vm.countShow(_vm.count.arap_unhandled_num)) ? _c('em', [_vm._v(_vm._s(_vm.count.arap_unhandled_num))]) : _vm._e()]), _vm._v("未确认\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "done",
    attrs: {
      "to": {
        path: '/account-check-bill',
        query: {
          bill_state: '1',
          bill_font: '已确认'
        }
      }
    }
  }, [_c('i'), _vm._v("已确认\n\t\t\t\t\t")])], 1)])])]), _vm._v(" "), _c('ul', {
    staticClass: "ui-listview refund"
  }, [_c('li', [_c('div', {
    staticClass: "head"
  }, [_c('h4', [_vm._v("供货商对账单")]), _vm._v(" "), _c('router-link', {
    staticClass: "ui-btn-icon-right ui-icon-carat-r",
    attrs: {
      "to": {
        path: '/supplier-account-check-bill',
        query: {
          bill_state: '0,1',
          bill_font: '未对账,已对账'
        }
      }
    }
  }, [_vm._v("查看全部对账单")])], 1), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    staticClass: "wait",
    attrs: {
      "to": {
        path: '/supplier-account-check-bill',
        query: {
          bill_state: '0',
          bill_font: '未对账'
        }
      }
    }
  }, [_c('i', [(_vm.countShow(_vm.count.reconciliation_unhandled_num)) ? _c('em', [_vm._v(_vm._s(_vm.count.reconciliation_unhandled_num))]) : _vm._e()]), _vm._v("未对账\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "done",
    attrs: {
      "to": {
        path: '/supplier-account-check-bill',
        query: {
          bill_state: '1',
          bill_font: '已对账'
        }
      }
    }
  }, [_c('i', [(_vm.countShow(_vm.count.reconciliation_accept_num)) ? _c('em', [_vm._v(_vm._s(_vm.count.reconciliation_accept_num))]) : _vm._e()]), _vm._v("已对账\n\t\t\t\t\t")])], 1)])])]), _vm._v(" "), _c('tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tips),
      expression: "tips"
    }],
    attrs: {
      "btnNum": _vm.btnNum,
      "tipsFont": _vm.tipsFont
    },
    on: {
      "tipStatus": _vm.tipStatus
    }
  }), _vm._v(" "), _c('tips-auto', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsauto),
      expression: "tipsauto"
    }],
    attrs: {
      "tipsFont": _vm.tipsFont
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7de84b2b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Reciept.vue
// module id = 599
// module chunks = 1